<script lang="ts" setup>

import { useI18n } from "vue-i18n";
import { buildMeta } from "~~/utils/meta-builder";

interface Entry {
  nr: string
  title: string
  body: string
}

useHead(buildMeta({ key: "terms", follow: false }));
const config = useRuntimeConfig();
const i18n = useI18n();
const emails = config.public.email
const supportEmail = `<a class="text-link hover:text-white" href="mailto:${emails.support}">${emails.support}</a>`;
const tm = <any>i18n.tm("terms.entries");
const entries = <Entry[]>tm.map((item: any) => <Entry>{ nr: i18n.rt(item.nr) + ".", title: i18n.rt(item.title), body: i18n.rt(item.body, { "support_email": supportEmail }) });
const list = ref(entries)

</script>
<template>
    <div class="bg-primary-500">
        <Header theme="dark"></Header>
        <div class="w-full md:max-w-screen-md mx-auto text-white px-6 md:px-0">  
            <div class="text-white py-20">
                <h1 class="font-bold text-3xl md:text-4xl break-all font-owners">{{$t('terms.title')}}</h1>
                <p class="text-2xl py-4 font-light text-white/75">{{$t('terms.body')}}</p>
            </div>
            <TermsItem v-for="item in list" :key="item.nr" :nr="item.nr" :title="item.title" :body="item.body" />
        </div> 
        <Footer ></Footer>
    </div>
</template>

